import classNames from 'classnames';
import * as React from 'react';
import { Link } from '../Link/Link';
import { LinkType } from '../Link/LinkType.csharp';
import { LinkVariant } from '../Link/LinkVariant.csharp';
import { Picture } from '../Picture/Picture';
import { PictureProfiles } from '../Picture/PictureProfiles';
import styles from './Callout.module.css';
import { CalloutBackgroundVariant } from './CalloutBackgroundVariant.csharp';
import type { CalloutProps } from './CalloutProps.csharp';

export const Callout: React.FC<React.PropsWithChildren<CalloutProps>> = props => {
    const { title, text, link, image, backgroundVariant } = props;

    const getLinkVariant = () => {
        switch (backgroundVariant) {
            case CalloutBackgroundVariant.Primary:
                return LinkVariant.Primary;
            case CalloutBackgroundVariant.Secondary:
                return LinkVariant.Secondary;
            default:
                return LinkVariant.Default;
        }
    };

    return (
        <div
            className={classNames(
                styles.Callout,
                backgroundVariant !== 'default' && styles[`Variant--${backgroundVariant}`],
                image && image.url && styles['Variant--withImage']
            )}
        >
            {image && image.url && <Picture {...image} profile={PictureProfiles.callout} className={styles.Image} />}
            <div className={styles.Content}>
                {title && <p className={styles.Title}>{title}</p>}
                {text && <p className={styles.Text}>{text}</p>}
                {link && link.href && (
                    <Link {...link} type={LinkType.Default} variant={getLinkVariant()} className={styles.Link} />
                )}
            </div>
        </div>
    );
};
